module.exports = __webpack_public_path__ + "static/img/404.9509a7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/404.png
// module id = zAji
// module chunks = 1